import { AppConfig } from "@config/config";
import { GirlApiClient } from "./GirlApiClient";

export const girlApiClient = new GirlApiClient({ baseUrl: AppConfig.GIRLS_API_URL });
